/* Mockridge vanity PDP. Upload as assets/vanity-pdp.js. Loaded by the vanity PDP section with defer. */
(function(){
(function(){
var placements = [
{ el: document.getElementById('mpKlarna'),    fb: document.getElementById('mpKlarnaFallback') },
{ el: document.getElementById('mpKlarnaTop'), fb: document.getElementById('mpKlarnaTopFallback') }
].filter(function(p){ return p.el; });
var priceEl = document.getElementById('mpAtcPrice');
if(!placements.length || !priceEl) return;
function currentAmount(){
var num = (priceEl.textContent || '').replace(/[^0-9.]/g,'');
if(!num) return null;
var amount = Math.round(parseFloat(num) * 100);
return isNaN(amount) ? null : amount;
}
function syncAmount(){
var amount = currentAmount();
if(amount === null) return;
placements.forEach(function(p){ p.el.setAttribute('data-purchase-amount', amount); });
}
function tryActivate(){
if(window.Klarna && window.Klarna.OnsiteMessaging){
syncAmount();
placements.forEach(function(p){
p.el.removeAttribute('hidden');
if(p.fb) p.fb.style.display = 'none';
});
if(window.Klarna.OnsiteMessaging.refresh) window.Klarna.OnsiteMessaging.refresh();
return true;
}
return false;
}
var tries = 0;
var poll = setInterval(function(){
tries++;
if(tryActivate() || tries > 20) clearInterval(poll);
}, 300);
new MutationObserver(function(){
syncAmount();
if(window.Klarna && window.Klarna.OnsiteMessaging && window.Klarna.OnsiteMessaging.refresh){
window.Klarna.OnsiteMessaging.refresh();
}
}).observe(priceEl, {childList:true, characterData:true, subtree:true});
})();
})();
(function(){
(function(){
var trigger = document.getElementById('mpRating');
if(!trigger) return;
var selectors = '#looxReviews, .loox-reviews-default, .loox-reviews-carousel, [data-loox-carousel], [class*="loox-reviews"], [id^="looxReviews"]';
function findReviews(){
var nodes = document.querySelectorAll(selectors);
for(var i = 0; i < nodes.length; i++){
if(nodes[i].getClientRects().length) return nodes[i];
}
return null;
}
trigger.addEventListener('click', function(e){
var target = findReviews();
if(!target) return;
e.preventDefault();
var parentDetails = target.closest ? target.closest('details') : null;
if(parentDetails && !parentDetails.open) parentDetails.open = true;
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var top = target.getBoundingClientRect().top + window.pageYOffset - 32;
window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
});
})();
})();
(function(){
var D=JSON.parse(document.getElementById('mpData').textContent);
document.querySelectorAll('.mp__modal').forEach(function(m){document.body.appendChild(m);});
var SKEY='mpConfig';
var stateReady=false;
function loadState(){try{return JSON.parse(sessionStorage.getItem(SKEY)||'null');}catch(e){return null;}}
function saveState(){
if(!stateReady)return;
try{
var st={o:{1:cleanName(sel[1]||''),2:cleanName(sel[2]||''),3:cleanName(sel[3]||'')}};
if(typeof bpOn!=='undefined'){st.bp=bpOn;st.bpSpec=bpField?bpField.value:'';}
if(typeof upChk!=='undefined'&&upChk){st.up=upChk.checked;var r=upWrap.querySelector('input[name="mpCorner"]:checked');st.upCorner=r?r.value:'';st.upHeight=document.getElementById('mpUpstandHeight').value;}
if(typeof wOn!=='undefined'){st.w=wOn;st.wVal=wRange?wRange.value:'';st.wNotes=(document.getElementById('mpWidthNotes')||{}).value||'';if(hIn)st.h=hIn.value;if(dIn)st.d=dIn.value;}
sessionStorage.setItem(SKEY,JSON.stringify(st));
}catch(e){}
}
function clearState(){try{sessionStorage.removeItem(SKEY);}catch(e){}}
var variants=D.variants;
var sel={1:variants[0].o1,2:variants[0].o2,3:variants[0].o3};
var updating=false;
function fmt(pence){
var p=(pence/100);
var s=p.toFixed(2).replace(/\.00$/,'').replace(/(\.\d)0$/,'$1');
return '\u00a3'+s.replace(/\B(?=(\d{3})+(?!\d))/g,',');
}
function find(){
for(var i=0;i<variants.length;i++){
if(variants[i].o1===sel[1]&&(variants[i].o2||null)===(sel[2]||null)&&(variants[i].o3||null)===(sel[3]||null))return variants[i];
}
return variants[0];
}
var QI=D.quartzIdx||1;
var baseNames={};baseNames[QI]='No quartz worktop';
var quartzOrder=['Pure White','Carrara Cashmere','Carrara Misterio','Calacatta Gold','Calacatta Oro','Calacatta Vincente','Arabescato Vagli','Misterio Gold','Viola'];
function uniqueOpts(n){
var seen={},out=[];
for(var i=0;i<variants.length;i++){
var v=variants[i]['o'+n];
if(!seen[v]){seen[v]=true;out.push(v);}
}
if(n===QI){
out.sort(function(a,b){
var ia=quartzOrder.indexOf(cleanName(a)),ib=quartzOrder.indexOf(cleanName(b));
if(isNone(a))return -1;if(isNone(b))return 1;
return (ia<0?99:ia)-(ib<0?99:ib);
});
}
return out;
}
function isNone(val){if(val===''||val===null||val===undefined)return true;return /^none\b/i.test(String(val).trim());}
function priceFor(n,val){
for(var i=0;i<variants.length;i++){
var v=variants[i],hit=true;
for(var k=1;k<=3;k++){
var want=(k===n)?val:sel[k];
if(v['o'+k]!==want){hit=false;break;}
}
if(hit)return v.price;
}
return null;
}
function cleanName(val){
return String(val).replace(/\s*\(\s*\+?\s*\u00a3?[0-9.,]+\s*\)\s*/g,'').trim();
}
function lookupLabel(n,val){
if(n===QI&&isNone(val))return baseNames[QI];
if(D.upstandIdx&&n===D.upstandIdx&&isNone(val))return 'No upstand';
var name=cleanName(val);
var opts=uniqueOpts(n);
var base=priceFor(n,opts[0]),mine=priceFor(n,val);
if(base===null||mine===null||mine<=base)return name;
return name+' (+'+fmt(mine-base)+')';
}
var stones=D.stones||{};
var stoneWrap=document.getElementById('mpQuartz');
var stoneVal=document.getElementById('mpQuartzVal');
var prev=document.getElementById('mpQuartzPreview');
function stoneImg(name,w){var st=stones[cleanName(name)];if(!st)return '';return st.img.replace(/\.(png|jpg|jpeg)\?/i,'_'+w+'x'+w+'.$1?');}
var stonesBuilt=false;
function buildStones(){
if(!stoneWrap)return;
var opts=uniqueOpts(QI);
if(!stonesBuilt){
stoneWrap.innerHTML='';
opts.forEach(function(o){
var b=document.createElement('button');b.type='button';b.className='mp__stone';b.dataset.val=o;
var nm=isNone(o)?'No worktop':cleanName(o);b.title=nm;b.setAttribute('aria-label',nm);
if(isNone(o)){b.classList.add('mp__stone--none');b.innerHTML='<span></span>';}
else{var src=stoneImg(o,400);b.innerHTML=src?'<span class="mp__stone-clip"><img src="'+src+'" alt=""></span>':'<span></span>';}
b.addEventListener('click',function(){if(updating)return;sel[QI]=o;upd();});
stoneWrap.appendChild(b);
});
var grid=document.getElementById('mpQuartzGrid');
if(grid){grid.innerHTML='';opts.forEach(function(o){if(isNone(o))return;var st=stones[cleanName(o)];var c=document.createElement('div');c.className='mp__stone-card';c.innerHTML=(st?'<img src="'+stoneImg(o,600)+'" alt="'+cleanName(o)+'" loading="lazy">':'')+'<p class="mp__stone-card-name">'+cleanName(o)+'</p>'+(st?'<p class="mp__stone-card-desc">'+st.desc+'</p>':'');grid.appendChild(c);});}
stonesBuilt=true;
}
var cur=sel[QI];
stoneWrap.querySelectorAll('.mp__stone').forEach(function(b){b.classList.toggle('mp__stone--on',b.dataset.val===cur);});
if(stoneVal)stoneVal.textContent=lookupLabel(QI,cur).replace(/\s*\(\+/,' +').replace(/\)$/,'');
var st=stones[cleanName(cur)];
if(prev){
if(isNone(cur)||!st){prev.hidden=true;}
else{prev.hidden=false;document.getElementById('mpQuartzPreviewImg').src=stoneImg(cur,1000);document.getElementById('mpQuartzPreviewImg').alt=cleanName(cur);document.getElementById('mpQuartzPreviewName').textContent=cleanName(cur);document.getElementById('mpQuartzPreviewDesc').textContent=st.desc;}
}
}
var handleHex={'Brushed Brass':'#b8935a','Matte Black':'#1a1a1a','Satin Nickel':'#b9b9b6','Polished Chrome':'#d9d9d9'};
function buildDD(id,n){
var dd=document.getElementById(id);
if(!dd)return;
var opts=uniqueOpts(n);
var curVal=sel[n];
dd.innerHTML='';
opts.forEach(function(o){
var b=document.createElement('button');b.type='button';
b.className='mp__pill'+(o===curVal?' mp__pill--on':'');
var lbl=lookupLabel(n,o);var mm=lbl.match(/^(.*?)\s*\((\+£[\d,]+)\)$/);
var name=cleanName(o);
var hex=handleHex[name];
if(/^none\s*\/\s*supplying/i.test(name)){lbl='Supply my own';mm=null;}
b.innerHTML=(hex?'<span class="mp__pill-dot" style="background:'+hex+'"></span>':'')+'<span class="mp__pill-name">'+(mm?mm[1]:lbl)+'</span>'+(mm?'<span class="mp__pill-price">'+mm[2]+'</span>':'');
b.addEventListener('click',function(){if(updating)return;sel[n]=o;upd();});
dd.appendChild(b);
});
}
function upd(){
if(updating)return;
updating=true;
var v=find();
document.getElementById('mpVid').value=v.id;
var p=fmt(v.price);
document.getElementById('mpPrice').textContent=p;
document.getElementById('mpAtcPrice').textContent=p;
var b=document.getElementById('mpAtc');
if(v.ok){
b.querySelector('.mp__atc-text').textContent='Add to Cart';
b.disabled=false;b.style.opacity='1';
} else {
b.querySelector('.mp__atc-text').textContent='Unavailable';
b.disabled=true;b.style.opacity='.4';
}
buildStones();
document.querySelectorAll('.mp__pills[data-option]').forEach(function(g){if(g.id!=='mpQuartz')buildDD(g.id,parseInt(g.dataset.option,10));});
syncUpstand(v);
updating=false;
saveState();
}
var upWrap=document.getElementById('mpUpstand');
var upChk=document.getElementById('mpUpstandChk');
var upDetail=document.getElementById('mpUpstandDetail');
function upSel(){
var r=upWrap?upWrap.querySelector('input[name="mpCorner"]:checked'):null;
return r?{vid:parseInt(r.dataset.vid,10),price:parseInt(r.dataset.price,10)||0,corners:r.value}:null;
}
var wBtn=document.getElementById('mpWidthBtn');
var hIn=document.getElementById('mpHeight'),dIn=document.getElementById('mpDepth');
function dimVal(el){if(!el)return null;var v=parseInt(el.value,10);var mn=parseInt(el.min,10),mx=parseInt(el.max,10);if(isNaN(v))v=parseInt(el.dataset.std,10);v=Math.max(mn,Math.min(mx,Math.round(v/10)*10));el.value=v;return v;}
function dimText(el){var v=dimVal(el);if(v===null)return '';var std=parseInt(el.dataset.std,10);return v+'mm'+(v===std?' (standard)':' (bespoke, standard '+std+'mm)');}
var wWrap=document.getElementById('mpWidth');
var wRange=document.getElementById('mpWidthRange');
var wNum=document.getElementById('mpWidthNum');
var wBasis=document.getElementById('mpWidthBasis');
var wOn=false,wBase=null,wBaseExact=true,wBaseVariant=null,wCache={};
var wVid=D.wVid;
var wPrice=D.wPrice;
var sizeMap=D.sizeMap||{};
var sizeMapAny=D.sizeMapAny||{};
var sizeKeys=Object.keys(sizeMap).map(Number).sort(function(a,b){return a-b;});
var sizeKeysAny=Object.keys(sizeMapAny).map(Number).sort(function(a,b){return a-b;});
var wMin=D.wMin||500;
var wTop=sizeKeysAny.length?sizeKeysAny[sizeKeysAny.length-1]:1600;
var wMax=(wVid&&wPrice>0)?1800:wTop;
if(D.wCap&&D.wCap>wMax)wMax=D.wCap;
if(wRange){wRange.min=wMin;wNum.min=wMin;wRange.max=wMax;wNum.max=wMax;var ends=wWrap?wWrap.querySelector('.mp__range-ends'):null;if(ends){ends.firstElementChild.textContent=wMin+'mm';ends.lastElementChild.textContent=wMax+'mm';}}
function oversize(w){return wPrice>0&&w>wTop;}
var curConfig=D.config||'Single';
var bandTop=(D.wMin&&D.wMin>=900)?1000:1200;
function configFor(w){return w>bandTop?'Double':(w<bandTop?'Single':curConfig);}
var priceEl=document.getElementById('mpPrice');
var sizeVal=document.getElementById('mpSizeVal');
var curSize=D.curSize;
var sizeBtns=Array.prototype.slice.call(document.querySelectorAll('.mp__sizes a.mp__sz'));
function markSize(b){sizeBtns.forEach(function(a){a.classList.toggle('mp__sz--on',parseInt(a.textContent,10)===b);});}
var sizeDefault=sizeVal?sizeVal.textContent:'';
var optNames=D.optNames;
function baseFor(w){
for(var i=0;i<sizeKeys.length;i++){if(sizeKeys[i]>=w)return {size:sizeKeys[i],exact:true};}
for(var k=0;k<sizeKeysAny.length;k++){if(sizeKeysAny[k]>=w)return {size:sizeKeysAny[k],exact:false};}
if(sizeKeysAny.length)return {size:sizeKeysAny[sizeKeysAny.length-1],exact:false};
return {size:sizeKeys[sizeKeys.length-1],exact:true};
}
function loadBase(size){
var url=sizeMap[size]||sizeMapAny[size];
if(wCache[url])return Promise.resolve(wCache[url]);
return fetch(url+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(j){wCache[url]=j;return j;});
}
function matchVariant(prod){
var vs=prod.variants,best=null;
for(var i=0;i<vs.length;i++){
var v=vs[i],hit=true;
for(var k=0;k<optNames.length;k++){
var want=sel[k+1]||'';
var have=v['option'+(k+1)]||'';
if(cleanName(have)!==cleanName(want)&&!(isNone(have)&&isNone(want))){hit=false;break;}
}
if(hit&&v.available)return v;
if(hit&&!best)best=v;
}
return best||vs[0];
}
function widthVal(){
var w=parseInt(wRange.value,10);
if(isNaN(w))w=wMin;
w=Math.max(wMin,Math.min(wMax,Math.round(w/10)*10));
return w;
}
function syncWidth(){
if(!wWrap||!wOn)return;
saveState();
var w=widthVal();
wNum.value=w;wRange.value=w;
if(sizeVal)sizeVal.textContent='Bespoke '+w+'mm';
var bf=baseFor(w);var b=bf.size;
var std=sizeKeys.indexOf(w)>-1;
var cfg=configFor(w);
var swap=cfg!==curConfig;
if(std)wBasis.textContent=hIn?(w+'mm is a standard width. Adjust height or depth below, or pick the size above.'):(w+'mm is a standard size. Pick it above.');
else if(oversize(w))wBasis.textContent='Priced as the '+b+'mm unit plus '+fmt(wPrice)+' for widths over '+wTop+'mm. Made to '+w+'mm wide'+(swap?' as a '+cfg.toLowerCase()+' unit.':'.');
else wBasis.textContent='Priced as the '+b+'mm unit, the next size up. Made to '+w+'mm wide'+(swap?' as a '+cfg.toLowerCase()+' unit.':'.');
if(swap)wBasis.textContent+=' Release the slider to switch to the '+cfg.toLowerCase()+'.';
wBase=b;wBaseExact=bf.exact;
markSize(bf.exact?b:0);
loadBase(b).then(function(prod){
wBaseVariant=matchVariant(prod);
syncUpstand(find());
}).catch(function(){wBaseVariant=null;});
}
function setWidth(on){
wOn=on;
if(wBtn){wBtn.classList.toggle('mp__sz--on',on);wBtn.setAttribute('aria-pressed',on?'true':'false');}
if(wWrap)wWrap.hidden=!on;
if(!on){wBaseVariant=null;if(sizeVal)sizeVal.textContent=sizeDefault;markSize(curSize);}
if(on)syncWidth();else syncUpstand(find());
}
if(wBtn){
wBtn.addEventListener('click',function(){setWidth(!wOn);saveState();});
wRange.addEventListener('input',function(){clearTimeout(hopT);wNum.value=wRange.value;syncWidth();});
document.getElementById('mpWidthNotes').addEventListener('input',saveState);
[hIn,dIn].forEach(function(el){if(el)el.addEventListener('change',function(){dimVal(el);saveState();});});
var hopT=null;function hopSoon(){clearTimeout(hopT);hopT=setTimeout(function(){syncWidth();hopToBase();},250);}
['pointerup','touchend','mouseup','keyup'].forEach(function(ev){wRange.addEventListener(ev,hopSoon);});
wNum.addEventListener('change',function(){wRange.value=wNum.value;syncWidth();hopToBase();});
}
function hopToBase(){
if(!wOn||!wBase)return;
var w=widthVal();
var target=null;
var cfg=configFor(w);
if(cfg!==curConfig){
var others=sizeKeysAny.filter(function(k){return !sizeMap[k];});
var pick=null;
if(cfg==='Double'){for(var i=0;i<others.length;i++){if(others[i]>=w&&others[i]>=1200){pick=others[i];break;}}if(pick===null&&others.length)pick=others[others.length-1];}
else{for(var k=others.length-1;k>=0;k--){if(others[k]<=1200){pick=others[k];break;}}}
if(pick!==null)target=sizeMapAny[pick];
}
else if(wBaseExact&&wBase!==curSize&&sizeMap[wBase])target=sizeMap[wBase];
if(!target)return;
saveState();
var q='?y='+Math.round(wWrap.getBoundingClientRect().top);
window.location.href=target+q;
}
function matchOpt(n,val){
var opts=uniqueOpts(n);
for(var i=0;i<opts.length;i++){if(cleanName(opts[i]||'')===val)return opts[i];}
return null;
}
function restoreState(){
var st=loadState();
var ps=new URLSearchParams(window.location.search);
if(st&&st.o){['1','2','3'].forEach(function(k){var m=matchOpt(parseInt(k,10),st.o[k]);if(m!==null)sel[k]=m;});upd();}
if(st&&upChk&&st.up){
upChk.checked=true;
var r=upWrap.querySelector('input[name="mpCorner"][value="'+(st.upCorner||'')+'"]');if(r)r.checked=true;
document.getElementById('mpUpstandHeight').value=st.upHeight||'';
}
if(st&&bpDot&&st.bp){bpField.value=st.bpSpec||'';setBespoke(true);}
if(st&&wBtn&&st.w&&st.wVal){
var rv=Math.max(wMin,Math.min(wMax,parseInt(st.wVal,10)||wMin));
wRange.value=rv;wNum.value=rv;
var n=document.getElementById('mpWidthNotes');if(n)n.value=st.wNotes||'';
if(hIn&&st.h)hIn.value=st.h;if(dIn&&st.d)dIn.value=st.d;
setWidth(true);
}else{syncUpstand(find());}
var y=parseInt(ps.get('y'),10);
if(!isNaN(y)&&wWrap){
if('scrollRestoration' in history)history.scrollRestoration='manual';
var fix=function(){window.scrollTo(0,wWrap.getBoundingClientRect().top+window.pageYOffset-y);};
fix();requestAnimationFrame(fix);setTimeout(fix,150);window.addEventListener('load',fix,{once:true});
}
}
var bpDot=document.getElementById('mpBespokeDot');
var bpWrap=document.getElementById('mpBespoke');
var bpField=document.getElementById('mpBespokeColour');
var bpOn=false;
var bpVid=D.bpVid;
var bpPrice=D.bpPrice;
var colourVal=document.getElementById('mpColourVal');
var colourDefault=colourVal?colourVal.textContent:'';
function setBespoke(on){
bpOn=on;
saveState();
if(bpDot){bpDot.classList.toggle('mp__dot--on',on);bpDot.setAttribute('aria-pressed',on?'true':'false');}
if(bpWrap)bpWrap.hidden=!on;
if(colourVal)colourVal.textContent=on?'Bespoke':colourDefault;
if(on&&bpField)bpField.focus();
syncUpstand(find());
}
if(bpDot){bpDot.addEventListener('click',function(){setBespoke(!bpOn);saveState();});bpField.addEventListener('input',saveState);}
function syncUpstand(v){
var unitPrice=v.price;
if(wOn&&wBase){var bu=sizeMap[wBase]||sizeMapAny[wBase];if(bu&&wCache[bu])wBaseVariant=matchVariant(wCache[bu]);}
if(wOn&&wBaseVariant)unitPrice=wBaseVariant.price;
var total=unitPrice+(bpOn?bpPrice:0)+((wOn&&oversize(widthVal()))?wPrice:0);
if(upWrap){
var hasQuartz=!isNone(v['o'+QI]);
upWrap.hidden=!hasQuartz;
if(!hasQuartz&&upChk.checked){upChk.checked=false;}
upDetail.hidden=!upChk.checked;
var u=upSel();
if(upChk.checked&&u)total+=u.price;
}
document.getElementById('mpAtcPrice').textContent=fmt(total);
if(priceEl)priceEl.textContent=fmt(total);
var sp=document.getElementById('mpStickyPrice');if(sp)sp.textContent=fmt(total);
}
if(upChk){
upChk.addEventListener('change',function(){syncUpstand(find());saveState();});
document.getElementById('mpUpstandHeight').addEventListener('input',saveState);
upWrap.querySelectorAll('input[name="mpCorner"]').forEach(function(r){
r.addEventListener('change',function(){syncUpstand(find());saveState();});
});
}
var form=document.getElementById('mpForm');
form.addEventListener('submit',function(e){
var spec='';
if(bpOn){
spec=(bpField.value||'').trim();
if(!spec){
e.preventDefault();
bpField.focus();
bpField.classList.add('mp__field--err');
return;
}
bpField.classList.remove('mp__field--err');
}
var wantUp=upChk&&upChk.checked;
if(!bpOn&&!wantUp&&!wOn){clearState();return;}
e.preventDefault();
var btn=document.getElementById('mpAtc');
btn.disabled=true;
var unit=document.title.split('|')[0].trim();
var mainId=parseInt(document.getElementById('mpVid').value,10);
var main={id:mainId,quantity:1,properties:{}};
if(wOn){
if(!wBaseVariant){btn.disabled=false;wBasis.textContent='Still checking the price, try again in a moment.';return;}
var w=widthVal();
var notes=(document.getElementById('mpWidthNotes').value||'').trim();
main.id=wBaseVariant.id;
if(sizeKeys.indexOf(w)>-1)main.properties['Width']=w+'mm (standard)';else main.properties['Width']='BESPOKE '+w+'mm (built to this width, priced as '+wBase+'mm)';
if(hIn)main.properties['Height']=dimText(hIn);
if(dIn)main.properties['Depth']=dimText(dIn);
main.properties[hIn?'Other requests':'Depth / other requests']=notes||(hIn?'None':'Standard depth');
unit=unit.replace(/\d{3,4}mm/,w+'mm bespoke');
}
if(bpOn){main.properties['Colour']='BESPOKE (ignore product colour)';main.properties['Bespoke colour reference']=spec;}
if(!Object.keys(main.properties).length)delete main.properties;
var items=[main];
if(wOn&&wVid&&wPrice>0&&oversize(widthVal()))items.push({id:wVid,quantity:1,properties:{'For':unit,'Width':widthVal()+'mm','Depth / other requests':(document.getElementById('mpWidthNotes').value||'').trim()||'Standard depth'}});
if(bpOn)items.push({id:bpVid,quantity:1,properties:{'For':unit,'Colour reference':spec}});
if(wantUp){
var u=upSel();
var height=(document.getElementById('mpUpstandHeight').value||'').trim();
if(u)items.push({id:u.vid,quantity:1,properties:{'For':unit,'Height / edge detail':height||'100mm standard'}});
}
fetch('/cart/add.js',{
method:'POST',
headers:{'Content-Type':'application/json','Accept':'application/json'},
body:JSON.stringify({items:items})
}).then(function(r){
if(!r.ok)throw new Error('add failed');
clearState();
window.location.href='/cart';
}).catch(function(){
btn.disabled=false;
form.submit();
});
});
document.querySelectorAll('.mp__vsel').forEach(function(dd){
dd.addEventListener('change',function(){
if(updating)return;
sel[dd.dataset.option]=dd.value;
upd();
});
});
upd();
restoreState();
stateReady=true;
saveState();
document.querySelectorAll('.mp__sizes a.mp__sz').forEach(function(a){
a.addEventListener('click',function(){wOn=false;wBaseVariant=null;saveState();});
});
document.querySelectorAll('.mp__dots a.mp__dot').forEach(function(a){
a.addEventListener('click',function(){bpOn=false;saveState();});
});
(function(){
if(!D.badgeImg)return;
var key=D.badgeImg.replace(/\.[a-z]+$/i,'');
var imgs=Array.prototype.slice.call(document.querySelectorAll('img'));
var target=null;
for(var i=0;i<imgs.length;i++){var src=imgs[i].currentSrc||imgs[i].src||imgs[i].getAttribute('data-src')||'';if(src.indexOf(key)>-1&&!imgs[i].closest('.mp')){target=imgs[i];break;}}
if(!target)return;
var host=target.parentElement;
if(getComputedStyle(host).position==='static')host.style.position='relative';
var b=document.createElement('div');b.className='mp__badge';
b.innerHTML='<svg viewBox="0 0 60 30" aria-hidden="true"><clipPath id="mpBadgeFlag"><path d="M0,0 v30 h60 v-30 z"/></clipPath><clipPath id="mpBadgeFlag2"><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"/></clipPath><g clip-path="url(#mpBadgeFlag)"><path d="M0,0 v30 h60 v-30 z" fill="#012169"/><path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" stroke-width="6"/><path d="M0,0 L60,30 M60,0 L0,30" clip-path="url(#mpBadgeFlag2)" stroke="#C8102E" stroke-width="4"/><path d="M30,0 v30 M0,15 h60" stroke="#fff" stroke-width="10"/><path d="M30,0 v30 M0,15 h60" stroke="#C8102E" stroke-width="6"/></g></svg><span class="mp__badge-head">'+D.badgeText+'</span>';
host.appendChild(b);
})();
var sticky=document.getElementById('mpSticky');
var stickyBtn=document.getElementById('mpStickyBtn');
var atcBtn=document.getElementById('mpAtc');
if(sticky&&atcBtn&&'IntersectionObserver' in window){
new IntersectionObserver(function(es){es.forEach(function(e){sticky.hidden=e.isIntersecting;});},{threshold:0,rootMargin:'0px 0px -60px 0px'}).observe(atcBtn);
stickyBtn.addEventListener('click',function(){if(form.requestSubmit)form.requestSubmit();else atcBtn.click();});
}
var toast=document.getElementById('mpBasinToast');
var toastTimer=null;
function showToast(msg){
if(!toast)return;
toast.textContent=msg;
toast.classList.add('mp__basin-toast--show');
clearTimeout(toastTimer);
toastTimer=setTimeout(function(){toast.classList.remove('mp__basin-toast--show');},2400);
}
document.querySelectorAll('[data-basin-pick]').forEach(function(pick){
pick.addEventListener('click',function(){var card=pick.closest('[data-basin-card]');var b=card&&card.querySelector('.mp__basin-add');if(b)b.click();});
});
function markBasin(btn,key){
var card=btn.closest('[data-basin-card]');var rm=card&&card.querySelector('[data-basin-remove]');
if(key){btn.setAttribute('data-added','');btn.dataset.key=key;if(rm)rm.hidden=false;}
else{btn.removeAttribute('data-added');delete btn.dataset.key;if(rm)rm.hidden=true;}
}
fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
document.querySelectorAll('.mp__basin-add').forEach(function(btn){
var vid=parseInt(btn.dataset.basinId,10);
for(var i=0;i<cart.items.length;i++){if(cart.items[i].variant_id===vid){markBasin(btn,cart.items[i].key);break;}}
});
}).catch(function(){});
document.querySelectorAll('.mp__basin-add').forEach(function(btn){
btn.addEventListener('click',function(){
if(btn.hasAttribute('data-added'))return;
var id=btn.dataset.basinId;
var name=btn.dataset.basinName||'Basin';
var qty=parseInt(btn.dataset.basinQty,10)||1;
btn.disabled=true;
fetch('/cart/add.js',{
method:'POST',
headers:{'Content-Type':'application/json','Accept':'application/json'},
body:JSON.stringify({id:id,quantity:qty})
}).then(function(r){
if(!r.ok)throw new Error('add failed');
return r.json();
}).then(function(item){
btn.disabled=false;
markBasin(btn,item.key);
showToast(qty>1 ? (qty+' '+name+' added to cart') : (name+' added to cart'));
document.dispatchEvent(new CustomEvent('cart:updated'));
}).catch(function(){
btn.disabled=false;
showToast('Could not add to cart. Please try again.');
});
});
});
document.querySelectorAll('[data-basin-remove]').forEach(function(rm){
rm.addEventListener('click',function(){
var card=rm.closest('[data-basin-card]');var btn=card.querySelector('.mp__basin-add');
var key=btn.dataset.key;if(!key)return;
rm.disabled=true;
fetch('/cart/change.js',{
method:'POST',
headers:{'Content-Type':'application/json','Accept':'application/json'},
body:JSON.stringify({id:key,quantity:0})
}).then(function(r){
if(!r.ok)throw new Error('remove failed');
rm.disabled=false;
markBasin(btn,null);
showToast((btn.dataset.basinName||'Basin')+' removed from cart');
document.dispatchEvent(new CustomEvent('cart:updated'));
}).catch(function(){
rm.disabled=false;
showToast('Could not remove. Please try again.');
});
});
});
})();